
import { useState, useCallback } from "react";
import { SessionEvent } from "../SessionEvent";

export const useSessionDialog = () => {
  const [isAddSessionDialogOpen, setIsAddSessionDialogOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [currentSession, setCurrentSession] = useState<SessionEvent | null>(null);

  const handleAddSessionClick = useCallback(() => {
    setCurrentSession(null);
    setSelectedDate(new Date());
    setIsAddSessionDialogOpen(true);
  }, []);

  const handleEditSession = useCallback((session: SessionEvent) => {
    setCurrentSession(session);
    setIsAddSessionDialogOpen(true);
  }, []);

  const handleDayClick = useCallback((date: Date) => {
    setSelectedDate(date);
    setCurrentSession(null);
    setIsAddSessionDialogOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setIsAddSessionDialogOpen(false);
    setCurrentSession(null);
    setSelectedDate(null);
  }, []);

  return {
    isAddSessionDialogOpen,
    setIsAddSessionDialogOpen,
    selectedDate,
    setSelectedDate,
    currentSession,
    setCurrentSession,
    handleAddSessionClick,
    handleEditSession,
    handleDayClick,
    closeDialog
  };
};
